// Lib
import { DragSource } from 'react-dnd';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty, defer } from 'lodash';

// Geometry utils
import { getUpdatedControlPoint } from './utils/lineControlPointUtil';

// Selectors
import { getUpdatedLinePointsOfInterest } from './lineControlPointSelector';
import getGridSize from '../../utils/grid/gridSizeSelector';
import { getShallowMeasurementsMap } from '../../components/measurementsStore/elementMeasurements/elementMeasurementsSelector';

// Constants
import { NO_DRAG_OFFSET } from '../../utils/dnd/dndConstants';
import { LINE_CONTROL_POINT_DND_TYPE } from '../../../common/lines/lineConstants';

const getDroppedControlPointPosition =
    ({ elementId, element, offsetDiff }) =>
    (dispatch, getState, { measurementsStore }) => {
        const state = getState();

        const measurements = getShallowMeasurementsMap(measurementsStore.getState());
        const linePois = getUpdatedLinePointsOfInterest(state, {
            elementId,
            element,
            offsetDiff,
            measurements,
        });

        const gridSize = getGridSize(state);

        const { start, end, controlPoint } = linePois;

        if (!start || !end || !controlPoint) return null;

        return getUpdatedControlPoint({ ...linePois, gridSize });
    };

const mapDispatchToProps = (dispatch) => ({
    dispatchGetDroppedControlPoint: (args) => dispatch(getDroppedControlPointPosition(args)),
});

const edgeDragSource = {
    beginDrag({ elementId, toggleLineVisibility, pos, element, dispatchPointDragStart }, monitor, component) {
        defer(toggleLineVisibility);
        dispatchPointDragStart();
        return { id: elementId, element, pos };
    },
    endDrag(props, monitor) {
        const { elementId, element, updateLineControlPoint, toggleLineVisibility, dispatchGetDroppedControlPoint } =
            props;

        // Doing nothing if it was not dropped onto a compatible target
        const dropResult = monitor.getDropResult();
        if (!monitor.didDrop() || isEmpty(dropResult)) {
            toggleLineVisibility();
            return;
        }

        const { offsetDiff = NO_DRAG_OFFSET } = dropResult;

        const control = dispatchGetDroppedControlPoint({ elementId, element, offsetDiff });

        updateLineControlPoint({ control });
        toggleLineVisibility();
    },
};

const dragCollect = (connector, monitor) => ({
    // Call inside render() to let React handle the drag event
    connectDragSource: connector.dragSource(),
    connectDragPreview: connector.dragPreview(),
    // Get current drag state from the monitor
    isDragging: monitor.isDragging(),
});

const enhance = compose(
    connect(null, mapDispatchToProps),
    DragSource(LINE_CONTROL_POINT_DND_TYPE, edgeDragSource, dragCollect),
);

export default enhance;
